module.exports = __webpack_public_path__ + "img/28_45.a22f02bb.png";